export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-12 2c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1zm-1.12 3.12c0-.64.51-1.12 1.12-1.12.63 0 1.13.48 1.13 1.12 0 .62-.51 1.13-1.13 1.13-.62 0-1.12-.5-1.12-1.13z\" fill=\"#F76902\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};